export default {
  isDev: process.env.NODE_ENV === 'development',
}
